import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./home";
import Workshop from "./workshop";

const LearnPublic = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/:id" element={<Workshop />} />
    </Routes>
  );
};

export default LearnPublic;
